import actionTypes from './actionTypes'

const goalsActions = {

	fetched: goals => ({
		type: actionTypes.GOALS_FETCHED,
		goals,
	}),

	failed: serverError => ({
		type: actionTypes.GOALS_FAILED,
		serverError,
	}),

	collaborateCardCreateLesson: () => ({
		type: actionTypes.GOALS_COLLABORATE_CARD_CREATE_LESSON,
	}),

	timeToClimbCardCreateLesson: () => ({
		type: actionTypes.GOALS_TIME_TO_CLIMB_CARD_CREATE_LESSON,
	}),

	timeToClimbEnableLessonSuccess: () => ({
		type: actionTypes.GOALS_TIME_TO_CLIMB_CARD_ENABLE_LESSON_SUCCESS,
	}),

	timeToClimbEnableLessonFailed: () => ({
		type: actionTypes.GOALS_TIME_TO_CLIMB_CARD_ENABLE_LESSON_FAILED,
	}),

	oeqCardCreateLesson: () => ({
		type: actionTypes.GOALS_OEQ_CARD_CREATE_LESSON,
	}),

	oeqCreateLessonSuccess: payload => ({
		type: actionTypes.GOALS_OEQ_CARD_CREATE_LESSON_SUCCESS,
		payload,
	}),

	oeqCreateLessonFailed: serverError => ({
		type: actionTypes.GOALS_OEQ_CARD_CREATE_LESSON_FAILED,
		serverError,
	}),

	oeqEnableLessonSuccess: () => ({
		type: actionTypes.GOALS_OEQ_CARD_ENABLE_LESSON_SUCCESS,
	}),

	oeqEnableLessonFailed: serverError => ({
		type: actionTypes.GOALS_OEQ_CARD_ENABLE_LESSON_FAILED,
		serverError,
	}),

	collaborateCardLaunchLiveLesson: presentation_uid => ({
		type: actionTypes.GOALS_COLLABORATE_CARD_LAUNCH_LIVE_LESSON,
		presentation_uid,
	}),

	timeToClimbCardLaunchLiveLesson: presentation_uid => ({
		type: actionTypes.GOALS_TIME_TO_CLIMB_CARD_LAUNCH_LIVE_LESSON,
		presentation_uid,
	}),

	oeqCardLaunchLiveLesson: presentation_uid => ({
		type: actionTypes.GOALS_OEQ_CARD_LAUNCH_LIVE_LESSON,
		presentation_uid,
	}),

	collaborateCardCreateLessonWithDemo: () => ({
		type: actionTypes.GOALS_COLLABORATE_CARD_CREATE_LESSON_WITH_DEMO,
	}),

	collaborateCardTooltipSelect: () => ({
		type: actionTypes.GOALS_COLLABORATE_CARD_TOOLTIP_SELECTED,
	}),
}

export default goalsActions
